import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../lib/api";
import CustomerHeader from "../../components/CustomerHeader";
import { StatusBadge } from "../../components/Shared";

export default function CustomerOrders() {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const load = async () => { const { data } = await api.get("/orders"); setOrders(data); };
  useEffect(() => { load(); const t = setInterval(load, 20000); return () => clearInterval(t); }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0C] grain">
      <CustomerHeader />
      <main className="max-w-4xl mx-auto px-4 lg:px-8 py-8 relative z-10">
        <h1 className="font-display font-black text-3xl tracking-tighter mb-6">I miei ordini</h1>
        <button data-testid="mercato-cta" onClick={() => navigate("/app/mercato")}
          className="w-full flex items-center justify-between bg-gradient-to-r from-[#00E676]/15 to-transparent border border-[#00E676]/40 rounded-xl p-4 mb-6 hover:border-[#00E676] transition-colors text-left">
          <div>
            <div className="font-semibold text-[#00E676]">Rider Mercato — Fai la spesa al mercato</div>
            <div className="text-sm text-zinc-400">Crea la lista, un rider autorizzato compra e ti consegna a casa.</div>
          </div>
          <span className="text-[#00E676] text-xl">→</span>
        </button>
        <div className="space-y-3">
          {orders.map((o) => (
            <div key={o.id} data-testid={`order-row-${o.id}`} onClick={() => navigate(`/app/orders/${o.id}`)}
              className="flex items-center justify-between bg-[#1C1C1F] border border-white/10 rounded-lg p-4 cursor-pointer hover:border-[#00E676]/40 transition-colors">
              <div>
                <div className="font-medium">{o.business_name}</div>
                <div className="text-sm text-zinc-500">#{o.id.slice(-5)} · {o.items.length} prodotti · €{o.total.toFixed(2)}</div>
                <div className="text-xs text-zinc-600 mt-1">{new Date(o.created_at).toLocaleString("it-IT")}</div>
              </div>
              <StatusBadge status={o.status} />
            </div>
          ))}
          {orders.length === 0 && <div className="text-zinc-500 py-16 text-center">Nessun ordine ancora.</div>}
        </div>
      </main>
    </div>
  );
}
